import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';

import FormClient from './index';

const useStyles = makeStyles ({
  dialogActions: {
    backgroundColor: '#013957',
    justifyContent: 'flex-start',
  },
  icon: {
    fontSize: 20,
    color: 'white'
  },
  dialogTitle: {
      color: 'white',
      padding: 0
  }, 
  dialogContent: {
      padding: 0
  }
});

export default function FormDialog({ openForm, handleClose, user }) {
  //const [open, setOpen] = React.useState(false);
  //const [scroll, setScroll] = React.useState('paper');

  /* const handleClickOpen = scrollType => () => {
    setOpen(true);
    setScroll(scrollType);
  }; */

  /*  const handleClose = () => {
    setOpen(false);
  }; */

  const classes = useStyles();
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (openForm) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [openForm]);

  return (
    <div>
      {/* <Button onClick={handleClickOpen('paper')}>scroll=paper</Button>
      <Button onClick={handleClickOpen('body')}>scroll=body</Button> */}
      <Dialog
        open={openForm}
        onClose={handleClose}
        //scroll={scroll}
        fullScreen
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogActions classes={{root: classes.dialogActions} }>
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>
          <DialogTitle id="scroll-dialog-title" className={classes.dialogTitle}>Contactar</DialogTitle>
        </DialogActions>

        <DialogContent className={classes.dialogContent}>
          <FormClient
            user={user}
            contact={user && user.contacto}
            onModal
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
